const SubAbas = [
  { label: 'Programação', rota: '/daf/programacao/progamacoes' },
];

export default SubAbas;
